<template>
  <div class="date-presets">
    <span>Quick period:</span>
    <button
      v-for="preset in presets"
      :key="preset.label"
      type="button"
      :class="{ active: preset.from === from && preset.to === to }"
      @click="$emit('select', { from: preset.from, to: preset.to })"
    >{{ preset.label }}</button>
  </div>
</template>

<script>
// One-click report periods. Emits `select` with { from, to } as YYYY-MM-DD; the page sets its
// own date filters and reloads. The financial year runs April to March.
function iso(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export default {
  name: "ReportDatePresets",
  props: {
    from: { type: String, default: "" },
    to: { type: String, default: "" },
  },
  emits: ["select"],
  computed: {
    presets() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      const yesterday = new Date(year, month, today.getDate() - 1);
      const fyStart = month >= 3 ? year : year - 1;
      return [
        { label: "Today", from: iso(today), to: iso(today) },
        { label: "Yesterday", from: iso(yesterday), to: iso(yesterday) },
        { label: "This Month", from: iso(new Date(year, month, 1)), to: iso(today) },
        { label: "Last Month", from: iso(new Date(year, month - 1, 1)), to: iso(new Date(year, month, 0)) },
        { label: "This FY", from: `${fyStart}-04-01`, to: iso(today) },
        { label: "Last FY", from: `${fyStart - 1}-04-01`, to: `${fyStart}-03-31` },
      ];
    },
  },
};
</script>

<style scoped>
.date-presets {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #e2e8f0;
}
.date-presets > span {
  font-size: 12px;
  color: #64748b;
  margin-right: 4px;
}
.date-presets button {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  border-radius: 999px;
  padding: 3px 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}
.date-presets button:hover {
  border-color: #3b82f6;
  color: #1d4ed8;
}
.date-presets button.active {
  background: #1d4ed8;
  border-color: #1d4ed8;
  color: #fff;
}
</style>
